export const mediaTags = {
  campaign: 'c',
  announcement: 'a'
}
